import React from 'react'
import DriversSection from '../sections/DriversSection/DriversSection'

const Drivers = () => {
  return (
    <DriversSection />
  )
}

export default Drivers